export const getThemeText = (slotDetails) => {
  if (slotDetails && slotDetails.current && slotDetails.current.officeTheme) {
    return `msteams-${slotDetails.current.officeTheme}`;
  } else {
    return slotDetails.theme;
  }
};
